import { AddressType } from "../../Types/addressType"


export const googleAddress = (address: AddressType) => {
    return `https://www.google.com/maps/place/${address.address1}+${address.city}+${address.state}`
}

export const formatAddress = (address: AddressType) => {
    let addressString = ''
    addressString += `${address.address1}`
    addressString += address.address2 ? ` #${address.address2}, ` : ', '
    addressString += `${address.city}, ${address.state} ${address.zip}`
    return addressString
}
